import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "title is-2" }, "Allowed domains", -1)
const _hoisted_4 = { class: "columns mt-6 is-multiline" }
const _hoisted_5 = { class: "column is-12" }
const _hoisted_6 = {
  key: 0,
  class: "column is-12 mt-6",
  ref: "loadingApplications"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Loading allowed domains...", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("progress", {
  class: "progress is-small is-link",
  max: "100"
}, "20%", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "notification is-danger is-light column is-12 mt-6"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "There was an error loading allowed domains", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "column is-12"
}
const _hoisted_14 = {
  key: 0,
  class: "list",
  "data-test": "list-domains"
}
const _hoisted_15 = {
  key: 1,
  class: "title is-5 is-info"
}
const _hoisted_16 = {
  key: 1,
  class: "container is-tp-container"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "title is-2" }, "You don't have the required permissions to manage domains", -1)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormAllowedDomain = _resolveComponent("FormAllowedDomain")!
  const _component_AllowedDomainItem = _resolveComponent("AllowedDomainItem")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.allowed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_FormAllowedDomain, {
                onPushItem: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createDomainItem($event))),
                loading: _ctx.loadingCreation
              }, null, 8, ["loading"])
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9, 512))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_ctx.domains.length > 0)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.domains, (domain) => {
                                return (_openBlock(), _createBlock(_component_AllowedDomainItem, {
                                  domain: domain,
                                  key: domain.id,
                                  onEditItem: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editDomainItemFromArray($event))),
                                  onDeleteItem: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteDomainItemFromArray($event)))
                                }, null, 8, ["domain"]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_15, "Looks like there are no domains yet"))
                      ]))
                ], 64))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
  ]))
}